import { useMemo } from 'react';
import { UserRankingDto } from '@repo/shared/dtos/analytics/UtilizationDto';

const TOP_USERS_PAGE_SIZE = 20;

export function useMemberPagination(data: UserRankingDto[], currentPage: number) {
  const totalPages = Math.ceil(data.length / TOP_USERS_PAGE_SIZE);
  const startRank = (currentPage - 1) * TOP_USERS_PAGE_SIZE + 1;

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * TOP_USERS_PAGE_SIZE;
    return data.slice(startIndex, startIndex + TOP_USERS_PAGE_SIZE);
  }, [data, currentPage]);

  return {
    paginatedData,
    totalPages,
    startRank,
  };
}
